// extracted by mini-css-extract-plugin
export default {"header":"Header_header__3KrT3","headLeftWrapper":"Header_headLeftWrapper__sMpAV","img":"Header_img__U7NsA","flex":"Header_flex__juZo3","consult":"Header_consult__P+wLB"};